import Icon from '../components/Icon.vue'

Icon.register({
  car: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M500 176c7.8 0 13.5 7.3 11.6 14.9l-6 24c-1.3 5.3-6.1 9.1-11.6 9.1h-20.1c13.4 11.7 22.1 28.8 22.1 48v48c0 16.1-6.2 30.7-16 41.9v54.1c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32h-256v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-54.1c-9.8-11.3-16-25.8-16-41.9v-48c0-19.2 8.7-36.3 22.1-48h-20.1c-5.5 0-10.3-3.8-11.6-9.1l-6-24c-1.9-7.6 3.8-14.9 11.6-14.9h59.9l16.6-41.6c17.1-42.8 57.9-70.4 104-70.4h127c46.1 0 86.9 27.6 104 70.4l16.6 41.6h59.9zM147.9 158.2l-19.9 49.8h256l-19.9-49.8c-7.3-18.2-24.9-30.2-44.6-30.2h-127c-19.6 0-37.3 12-44.6 30.2zM96 319.8c19.2 0 48 3.2 48-16 0-19.1-28.8-47.8-48-47.8s-32 12.8-32 31.9c0 19.1 12.8 31.9 32 31.9zM416 319.8c19.2 0 32-12.8 32-31.9 0-19.1-12.8-31.9-32-31.9s-48 28.7-48 47.8c0 19.1 28.8 16 48 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/car.js
// module id = 1149
// module chunks = 0